<template>
    <div class="article-faqs-tile-booking">
        <p>
            Nope, you can just turn up on the day. But why not
            <nuxt-link to="/contact">let us know</nuxt-link> if you're planning on heading down. That way we'll be able
            to introduce you to some of our regulars.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsTileBooking',
};
</script>
